var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Nne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:gray;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.7,159.38l97.84-98.71c.21-.21.4-.42.58-.64,5.35-6.4-.76-15.99-8.94-14.36l-56.95,11.37L42,8.73c-4.63-6.94-15.73-4.48-16.48,3.83-.03.28-.04.57-.04.86l-.62,138.98c-.04,8.81,10.63,13.23,16.83,6.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 167,
    height: 167
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Nne);
export default __webpack_public_path__ + "static/media/1-nne.fd942293732412df3012a240aadc5eab.svg";
export { ForwardRef as ReactComponent };